import { useEffect } from 'react'

import { trackExperimentViewed as trackEV } from '@mc/track-event'

import { PERSONA_IN_TIERS_FLAG_NAME } from '../constants'

export const trackExperimentViewed = () => {
  trackEV(PERSONA_IN_TIERS_FLAG_NAME)
}

export const useTrackExperimentViewed = () => {
  useEffect(() => {
    trackExperimentViewed()
  }, [])
}
